import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "label", "showFolded"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 18:13:19
 * @LastEditTime: 2021-04-22 18:21:35
 * @LastEditors: wangshengqiang
 * @Description: 常见问题组件
 */
import classnames from 'classnames';
import React, { useState } from 'react';
import { Icon } from 'zarm';
import { Iconfont } from '@/baseComponents';
const QuestionItem = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    children,
    label,
    showFolded = false
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const [folded, setFolded] = useState(true);
  const cls = classnames({
    'components-question-item-render': true,
    'item-folded': !!folded,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), /*#__PURE__*/React.createElement("div", {
    className: "item-header",
    onClick: () => showFolded && setFolded(!folded)
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mark"
  }, /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon-orange",
    type: "biansechangjianwenti"
  }), /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon-light",
    type: "biansechangjianwenti"
  })), /*#__PURE__*/React.createElement("div", {
    className: "header-title"
  }, label), showFolded && /*#__PURE__*/React.createElement("div", {
    className: "header-fold"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon",
    type: "arrow-top"
  }))), !(showFolded && folded) && /*#__PURE__*/React.createElement("div", {
    className: "item-body"
  }, children));
});
export default QuestionItem;